/**
 * Created by Jerker Nord on 2016-04-13.
 * Refactored by Ning Jiang on 2016-12-6.
 */

import { Ease, Linear, TimelineMax, TweenLite, Timeline } from "gsap";
import { Sprite } from "pixi.js";
import {  ReelEngine } from "@nolimitcity/slot-game/bin/core/engines/reel/engine/ReelEngine";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export interface IExpandingConfig extends IExpandAnimateConfig {
    startSize:number;
    paddingY?:number;
    amountOfSymbols:number;
}

export interface IExpandAnimateConfig {
    toSize:     number;
    
    symbolID?:  number;
    reelID?:    number[];
    
    duration?:  number;
    scaling?:   boolean;
    ease?:      any;

    targetSym?: number;
    updateSize?:boolean;
    addOverflow?:boolean;

    skipSplit?:boolean;
}

export class PunkEnginePlayer extends ReelEngine {

    public StartTeaser():Timeline {
        this.nextTimeline = Helper.timeLineNuller(this.nextTimeline);
        this.nextTimeline = new TimelineMax({paused:true});
        // Start
        this.nextTimeline.fromTo(this, this.configDuration.START,{yPos:0}, {
            ease : this.configEase.START_TEASER,
            yPos : this.Config.STEP_DISTANCE,
        });
        return this.nextTimeline;
    }
  
    public StopTeaser(quickStop:boolean, steps:number = 0):Timeline {
        
        const stopTl:TimelineMax = new TimelineMax({
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted()
        });

        if(steps == 0) steps = this.Steps;
        for(var i = 0; i < steps; i++){
            stopTl.fromTo(this, this.configDuration.SPIN, {yPos:0}, {
                ease : Linear.easeNone,
                yPos : this.stepDistance,
            });
            stopTl.add(() => this.callbacks.onCompletedStepCallback());
        }

        this.duration = quickStop ? this.configDuration.QUICK_STOP :  this.configDuration.STOP;
        let ease:any = quickStop ? this.configEase.QUICK_STOP : this.configEase.STOP;
    
        let randomAmount:number = Math.random() > 0.5 ? 0.5 : 1.5;
        let rDistance:number = this.stepDistance*randomAmount;

        stopTl.add(() => this.callbacks.onStopCallback());
        stopTl.fromTo(this, this.duration, {yPos: 0}, {
            ease : ease,
            yPos : rDistance,
        });

        let norm:number = stopTl.totalDuration();
        let shakeHertz:number = 100;
        let shakeIntensity:number = 6;
        let shakeDuration:number = 0.7;
     
        stopTl.to(this, shakeDuration,{
            onUpdate:() => {
                var startTimer:number = this.activeTimeline!.time()-norm;
                var intensify:number =  startTimer/shakeDuration;
                this.yPos += Math.cos(startTimer*shakeHertz) * (shakeIntensity*intensify);
            }
        });
        stopTl.fromTo(this, this.duration*0.5, {yPos: rDistance}, {
            ease : ease,
            yPos : this.stepDistance,
        });
        // Remove if we have created an normal stop first.
        this.nextTimeline = null;
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }

    public ExpandSymbol(conf:IExpandingConfig):Timeline{ 

        /*
        * Calculation heaven for defining Size ratio for correct positioning and scaling depending on config.
        */

        // const configurr:IExpandingConfig = conf

        let totalSize:number = conf.startSize;
    
        let totalAmountOfSymbols:number = conf.amountOfSymbols;

        const convStepDistance:number = Math.abs(this.Config.STEP_DISTANCE);
        const originSizeRatio = totalAmountOfSymbols/totalSize;
        const paddingRatio:number = conf.paddingY ? (conf.paddingY*originSizeRatio) / convStepDistance : 0;
        const CalcTotalSize:number = totalSize + (paddingRatio * totalAmountOfSymbols);
        const sizeRatio:number = CalcTotalSize/totalAmountOfSymbols;

        const calculatedToSize:number = conf.toSize * sizeRatio;
        const sizePart:number = totalSize / ( (totalAmountOfSymbols-1) + conf.toSize);

        let duration:number = (conf.duration != undefined ? conf.duration : this.configDuration.EXPAND)!;
        let easeCurve:any = (conf.ease != undefined ? conf.ease : this.configEase.EXPAND)!;

        /*
        * -------------------------------------------------------------------------------------------------------
        */

        // Time to loop threw the symbols on the reel and give them the configData depending on their current positions.
        let Tweens:TweenLite[] = [];
        this.nextTimeline = new TimelineMax({
            paused:true,
            onComplete: () => { 
                // this.stepDistance = configData.updateSize ? (convStepDistance * sizePart) : convStepDistance; 
                this.callbacks.onCompletedExpanding ? this.callbacks.onCompletedExpanding() : null;
             }
        });

        totalAmountOfSymbols += conf.addOverflow ? this.overflowAmount : 0;
        const hasTarget:boolean = conf.targetSym != undefined;

        let offsetWithoutTarget:number = hasTarget ? 0 : (((totalSize/sizePart))-totalAmountOfSymbols);
 
        let newSmallSize:number = (convStepDistance * sizePart);
        let newLargeSize:number = (newSmallSize * (calculatedToSize));

        let accPosition:number = -convStepDistance*0.5 + (offsetWithoutTarget*newSmallSize)*0.5;

        for(let pos = 0; pos < totalAmountOfSymbols; pos++){
            
            let posID:number = pos + (conf.addOverflow ? 0 : this.Config.OVERFLOW_TOP + this.Config.RESULT_OVERFLOW);

            let isTarget:boolean = hasTarget && conf.targetSym == (posID - (this.Config.OVERFLOW_TOP + this.Config.RESULT_OVERFLOW));
            
            let targetSize:number = sizePart;
            if(isTarget) targetSize *= conf.toSize;

            let posDist:number = (isTarget ? newLargeSize : newSmallSize)/2;
            let targetPos:number = accPosition + posDist;

            let sym:Sprite = this._animateContainer.children[posID] as Sprite;
            let fromScaleY:number = sym.scale.y;

            if(conf.scaling){
                if(duration == 0) sym.scale.y = targetSize;
                else
                    Tweens.push(TweenLite.fromTo(sym.scale, duration, {y:fromScaleY}, {
                        y : targetSize,
                        ease: easeCurve
                    }));
            }

            let fromPosY:number = sym.position.y;
            if(duration == 0) sym.position.y = targetPos;
            else
                Tweens.push(TweenLite.fromTo(sym.position, duration, { y:fromPosY}, {
                    y : targetPos,
                    ease: easeCurve
                }));
            accPosition += posDist*2;
        }
        
        this.nextTimeline.add(Tweens);

        return this.nextTimeline;
    }

    public Step():Timeline {
        this.duration = this.configDuration.SPIN;
        this.nextTimeline = new TimelineMax({ 
            paused:true,
            onRepeat : () => this.callbacks.onCompletedStepCallback(),
            repeat: -1,
            repeatDelay: 0,
        });
        this.nextTimeline.fromTo(this, this.configDuration.SPIN, {yPos:0}, {
            ease : Linear.easeNone,
            yPos : this.stepDistance,
        });
        return this.nextTimeline;
    }

    public Stop(quickStop:boolean):Timeline {
        
        const stopTl:TimelineMax = new TimelineMax({ 
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted()
        });

        let ease:any = quickStop ? this.configEase.QUICK_STOP : this.configEase.STOP;
        this.duration = quickStop ? this.configDuration.QUICK_STOP :  this.configDuration.STOP;

        const stopStepDuration:number = this.duration/this.Steps;

        for(var i = 0; i < this.Steps; i++){
            stopTl.fromTo(this, stopStepDuration, {yPos:0}, {
                ease : Linear.easeNone,
                yPos : this.stepDistance,
            });
            stopTl.add(() => this.callbacks.onCompletedStepCallback());
        }
        
        stopTl.add([
            () => {
                this.callbacks.onStopCallback();
                this.onBounce();
            },
            TweenLite.fromTo(this, this.duration, {yPos: 0}, {
                ease : ease,
                yPos : this.stepDistance,
            })
        ]);

        // Remove if we have created an normal stop first.
        this.nextTimeline = null;
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }
}